import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { selectors as filtersSelectors } from '../Modules/filters';
import { transform as transformAssetTypeList } from 'utils/DataTransform/Asset/AssetTypeList';
import { transform as transformAssetTypeDetails } from 'utils/DataTransform/Asset/AssetTypeDetail';

export const getAssetTypeListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (list, globalDepartmentRecords) => {
    if (!list) return [];
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transformAssetTypeList(list, globalDepartmentList);
  },
);
export const getAssetTypeListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (!list) return [];
    return list;
  },
);

export const getTotalRowsCount = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);
export const getAssetTypeFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getAssetTypeDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transformAssetTypeDetails(details, globalDepartmentList);
  },
);

export const getAssetTypeFilterKey = createSelector(
  filtersSelectors.getFilterKey,
  filterKey => filterKey,
);
